import { render, staticRenderFns } from "./datEmbededViewAnonymComplaint.vue?vue&type=template&id=c88c6426"
import script from "./datEmbededViewAnonymComplaint.vue?vue&type=script&lang=js"
export * from "./datEmbededViewAnonymComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports